import Vue from 'vue'
import LmTooltip from '@/reusable/base-components/LmTooltip'
import Grid from '@/ui/Grid'
import Banner from '@/ui/Banner'
import RBtn from '@/ui/RBtn'
import RCheckbox from '@/ui/RCheckbox'
import RDropdown from '@/ui/RDropdown'
import RInput from '@/ui/RInput'
import BgImageLayout from '@/layouts/BgImageLayout'
import RInfo from '@/ui/RInfo'
import RCard from '@/ui/RCard'

Vue.component('LmTooltip', LmTooltip)
Vue.component('Grid', Grid)
Vue.component('Banner', Banner)
Vue.component('RBtn', RBtn)
Vue.component('RCheckbox', RCheckbox)
Vue.component('RDropdown', RDropdown)
Vue.component('RInput', RInput)
Vue.component('BgImageLayout', BgImageLayout)
Vue.component('RInfo', RInfo)
Vue.component('RCard', RCard)
